import {useState} from "react";
import styles from 'assets/jss/ProfileStyle';
import {Button, Grid} from "@mui/material";
import {makeStyles} from '@mui/styles';
import {digitsEnToFa} from "persian-tools2";
import {Form, Formik} from "formik";
import ProfileContainer from "components/EditAgentProfile/ProfileContainer";
import {validationScanCenter} from "components/EditAgentProfile/validation";
import CustomTextField from "components/EditAgentProfile/TextField";
import SaveButtonProfile from "components/EditAgentProfile/SaveButtonProfile";
import useAgentInfo from "hooks/useAgentInfo";
import useEditAgentProfile from "hooks/useEditAgentProfile";
import {cityOptions, findUserLocation, provinceOptions} from "../../helpers/findUserLocation";
import useProvince from "hooks/useProvince";
import AutoCompleteField from "components/Formik/AutoCompleteField";
import addressIcon from "assets/img/location.svg";

const useStyles = makeStyles(styles);

const EditScanCenterInfo = (props) => {
    const {setActiveEdit, activeEdit} = props;
    const {data} = useAgentInfo();
    const {data: provinceData} = useProvince();

    const {
        firstName,
        isScanCenter,
        phoneNumber,
        scanCenterAddress,
        lastName,
        userType,
        isMale,
        birthDate,
        yearsWithDiabet,
        insulinType,
        isUsingOralMedications,
        diabetType,
        scanCenterName,
        cityId,
        city
    } = data || {};

    const {city: userCityName, province} = findUserLocation(provinceData, cityId);

    const scanCenterDataList = [
        {id: 1, title: 'نام مرکز اسکن', value: scanCenterName},
        {id: 2, title: ' استان', value:  city?.province?.name},
        {id: 3, title: 'شهر', value: city?.name},
        {id: 4, title: 'آدرس', value: scanCenterAddress},

    ];
    const initialValues = {
        firstName,
        lastName,
        scanCenterName,
        phoneNumber,
        scanCenterAddress,
        cityId: cityId ? {name: userCityName, id: cityId} : null,
        provinceId: province ? {name: province?.name, id: province?.id} : null,
    }
    const [saveBtn, setSaveBtn] = useState({
        loading: false,
        wait: false
    });
    const editAgentProfile = useEditAgentProfile();

    const editAgentProfileHandler = (agentPutData) => {
        editAgentProfile.mutate({agentPutData});
        saveBtnHandler()
    };
    const editClick = () => {
        setActiveEdit((prev) => ({...prev, scanCenter: true}));
    };

    const cancelEditHandler = () => {
        setActiveEdit((prev) => ({...prev, scanCenter: false}));
    };


    const saveBtnHandler = () => {
        setSaveBtn((prev) => ({...prev, loading: true, wait: true}));
        setTimeout(() => {
            setSaveBtn((prev) => ({...prev, loading: false}));
            setTimeout(() => {
                setSaveBtn((prev) => ({...prev, wait: false}));
                cancelEditHandler();
            }, 2000);
        }, 3100);
    };

    const handleSubmit = (values) => {
        const {
            scanCenterAddress,
            cityId,
            scanCenterName
        } = values;
        console.log(scanCenterAddress)
        const agentPutData = {
            firstName,
            lastName,
            scanCenterName,
            scanCenterAddress,
            userType,
            isScanCenter,
            isMale,
            birthDate,
            yearsWithDiabet,
            insulinType,
            isUsingOralMedications,
            diabetType,
            cityId: cityId?.id,
        };
        editAgentProfileHandler(agentPutData)
    };

    const classes = useStyles();

    return (
        <ProfileContainer activeEdit={activeEdit} hiddenIcon={activeEdit.scanCenter} title='اطلاعات مرکز اسکن'
                          editClick={editClick} saveBtn={saveBtn}>
            {activeEdit.scanCenter ?
                <Formik
                    enableReinitialize
                    initialValues={initialValues}
                    validationSchema={validationScanCenter}
                    onSubmit={handleSubmit}>
                    {(props) => (
                        <Form>
                            <Grid spacing={'14px'} container>
                                <Grid item xs={12}>
                                    <CustomTextField
                                        {...props}
                                        name='scanCenterName'
                                        label={'نام مرکز اسکن '}
                                        type='text'
                                        maxLength={25}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <AutoCompleteField
                                        fromEditProfile
                                        options={provinceOptions(provinceData)}
                                        {...props}
                                        name='provinceId'
                                        label='استان :'
                                        placeholder='استان *'
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <AutoCompleteField
                                        fromEditProfile
                                        options={cityOptions(
                                            provinceData,
                                            props.values.provinceId?.id
                                        )}
                                        {...props}
                                        name='cityId'
                                        label='شهر :'
                                        placeholder='شهر *'
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <CustomTextField
                                        {...props}
                                        fullWidth
                                        type='text'
                                        name='scanCenterAddress'
                                        label='آدرس'

                                    />
                                </Grid>

                                <Grid className={classes.formBtnContainer} item xs={12}>
                                    <SaveButtonProfile saveBtn={saveBtn}/>
                                    <Button onClick={cancelEditHandler} className={classes.cancelBtn}>انصراف</Button>
                                </Grid>
                            </Grid>
                        </Form>
                    )}

                </Formik>
                :
                scanCenterDataList.map(({id, title, value}) => (
                    <Grid
                        key={id}
                        container
                        alignItems='center'
                        justifyContent='center'
                        m='20px 0'>
                        <Grid
                            item
                            xs={5}
                            className={classes.ProfileTitle}>
                            {title}:
                        </Grid>
                        <Grid
                            item
                            xs={7}
                            className={classes.ProfileValue}>
                            {value ? digitsEnToFa(value) : '_'}
                        </Grid>
                    </Grid>
                ))}
        </ProfileContainer>
    );
};
export default EditScanCenterInfo
